import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { mapDispatchToActions } from '@sparefoot/react-core/utils';

import { Image } from 'components/core/Image';
import { Button } from 'components/core/Button';
import { ClickToCall } from 'components/facility/ClickToCall';
import { phonePropType } from 'config/propTypes';
import { Paragraph } from 'components/core/Typography';
import { getTollfreePhoneNumber } from 'store/modules/phone';

import { Filter } from 'components/svg';
import mapToolBar from 'assets/images/map/map-tool-bar.svg';
import listIcon from 'assets/images/icons/list-icon-tool-bar.svg';

import './SearchPageFooter.scss'; // ensure casing matches actual filename on disk
import classNames from 'classnames';

export function SearchPageFooter({
	onOpenFilters,
	filtersCount,
	actions,
	viewListMap,
	handleViewListMap,
	withinCallCenterHours,
	phone,
	className,
}) {
	return (
		<div
			className={classNames(
				'sticky-search-footer',
				{ 'no-click-to-call': !withinCallCenterHours },
				className,
			)}
		>
			<Button
				className="sticky-search-footer__tool-bar-button"
				type="button"
				onClick={handleViewListMap}
			>
				{viewListMap ? (
					<Fragment>
						<Image
							src={mapToolBar}
							alt="Map tool bar icon"
						/>
						<Paragraph
							color="white"
							size="small"
							weight="medium"
							last
						>
							Map
						</Paragraph>
					</Fragment>
				) : (
					<Fragment>
						<Image src={listIcon} />
						<Paragraph
							color="white"
							size="small"
							weight="medium"
							last
						>
							List
						</Paragraph>
					</Fragment>
				)}
			</Button>
			<Button
				type="button"
				className="sticky-search-footer__filter"
				onClick={onOpenFilters}
				aria-label="Open filters"
			>
				<Filter />
				<Paragraph
					color="white"
					size="small"
					weight="medium"
					last
				>
					Filter
				</Paragraph>
				{filtersCount > 0 && (
					<span
						className="sticky-search-footer__filter-count"
						aria-label={`${filtersCount} filters selected`}
					>
						{filtersCount}
					</span>
				)}
			</Button>
			{withinCallCenterHours && (
				<ClickToCall
					phone={phone}
					onFetchNumber={actions.getTollfreePhoneNumber}
					phoneIcon
					buttonText="Need Help ?"
				/>
			)}
		</div>
	);
}

SearchPageFooter.propTypes = {
	onOpenFilters: PropTypes.func.isRequired,
	filtersCount: PropTypes.number,
	className: PropTypes.string,
	phone: phonePropType,
	actions: PropTypes.shape({
		getTollfreePhoneNumber: PropTypes.func.isRequired,
	}).isRequired,
	sticky: PropTypes.bool,
	hidden: PropTypes.bool,
	viewListMap: PropTypes.bool.isRequired,
	handleViewListMap: PropTypes.func.isRequired,
	withinCallCenterHours: PropTypes.bool.isRequired,
};

SearchPageFooter.defaultProps = {
	filtersCount: 0,
	phone: null,
	sticky: false,
	hidden: false,
};

const selector = (state) => ({
	phone: state.phone.headerPhone,
});

export default compose(
	connect(selector, { getTollfreePhoneNumber }, mapDispatchToActions),
)(SearchPageFooter);
